import { Grid, SimpleGrid, Skeleton, Stack, Card } from '@backyard-ui/core'

const PRODUCT_SKELETON_HEIGHT = '358px'
const PRODUCT_SKELETON_COUNT = 8
const FILTER_SKELETON_COUNT = 5

const AsideSkeleton = () => {
  return (
    <Stack direction="column" spacing="4">
      <Card.Root>
        <Card.Body>
          <Skeleton width="100%" height="40px" />
        </Card.Body>
      </Card.Root>

      {Array.from({ length: FILTER_SKELETON_COUNT }).map((_, index) => (
        <Card.Root key={`filter-skeleton-${index}`}>
          <Card.Body>
            <Stack direction="column" spacing="2">
              <Skeleton width="60%" height="20px" />
              <Skeleton width="100%" height="32px" />
              <Skeleton width="100%" height="32px" />
              <Skeleton width="80%" height="32px" />
            </Stack>
          </Card.Body>
        </Card.Root>
      ))}
    </Stack>
  )
}

const HeaderSkeleton = () => {
  return (
    <Card.Root>
      <Card.Body>
        <Stack direction="row" justify="space-between" align="center">
          <Skeleton width="250px" height="24px" />
          <Skeleton width="100px" height="24px" />
        </Stack>
      </Card.Body>
    </Card.Root>
  )
}

const ProductGridSkeleton = () => {
  return (
    <Card.Root>
      <Card.Body>
        <SimpleGrid
          columns={{
            initial: 2,
            sm: 3,
            md: 4
          }}>
          {Array.from({ length: PRODUCT_SKELETON_COUNT }).map((_, index) => (
            <Skeleton
              key={`product-skeleton-${index}`}
              width="100%"
              height={PRODUCT_SKELETON_HEIGHT}
            />
          ))}
        </SimpleGrid>
      </Card.Body>
    </Card.Root>
  )
}

/**
 * Complete tab skeleton that mirrors the actual tab content structure
 * Includes: Aside (filters) + Header + Product Grid
 */
export const TabSkeleton = () => {
  return (
    <Grid.Root isGrow data-testid="tab-skeleton">
      <Grid.Item
        size={{
          initial: 12,
          md: 0,
          lg: 3
        }}>
        <AsideSkeleton />
      </Grid.Item>

      <Grid.Item
        size={{
          initial: 12,
          md: 9
        }}>
        <Stack direction="column" spacing="4">
          <HeaderSkeleton />
          <ProductGridSkeleton />
        </Stack>
      </Grid.Item>
    </Grid.Root>
  )
}
